import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { ImportDuplicateModalComponent } from './import-duplicate-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule
  ],
  declarations: [ImportDuplicateModalComponent],
  providers: [],
  exports: [ImportDuplicateModalComponent]
})

export class ImportDuplicateModalModule {

}
